import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useOptions} from './';

const defaultOptions = {
    actionLocation: undef,
    adultsMax: undef,
    adultsMin: undef,
    centered: undef,
    childrenMax: undef,
    childrenMin: undef,
    disableTextInput: undef,
    fadeOutDuration: 0,
    id: 'guests',
    inputIconName: 'group',
    name: 'guests',
    placement: 'bottom',
    positionIconRight: undef,
    showClearButton: false,
    showContinue: undef,
    showInputIcon: undef,
    showPetOption: true,
    wdioPrefix: undef
};

function useGuestsOptions(props) {
    const {
        guestsOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useGuestsOptions};
